import { render } from "./NewsArticleComponent.vue?vue&type=template&id=539907be&scoped=true&ts=true"
import script from "./NewsArticleComponent.vue?vue&type=script&lang=ts"
export * from "./NewsArticleComponent.vue?vue&type=script&lang=ts"

import "./NewsArticleComponent.vue?vue&type=style&index=0&id=539907be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539907be"]])

export default __exports__